jQuery(document).ready(function ($) {

    $('.collapse__item').on('click', '.collapse__header', function () {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle('fast', "swing")
    });

});
